module.exports = __webpack_public_path__ + "static/media/niclasAhden.321251ab.jpg";